import * as ColorNames from "../common/colorNames";
import { makeBaseHex } from "../common/util";
export const PRIMARY = ColorNames.MARINER;
export const SECONDARY = ColorNames.THUNDER;
export const TERTIARY = Object.assign({}, ColorNames.WHITE, { buttonText: PRIMARY.hex }); // Tertiary is always white button blue background
export const BACKGROUND_COLOR = ColorNames.BLACK;
export const BRAND_PRIMARY = ColorNames.MARINER;
export const BRAND_SECONDARY = ColorNames.ATOMIC_TANGERINE;
export const SUCCESS = ColorNames.GREEN_LEAF;
export const INFO = ColorNames.HAVELOCK_BLUE;
export const WARNING = ColorNames.BUTTERCUP;
export const DANGER = ColorNames.MONZA;
export const LIGHT = ColorNames.ATHENS_GRAY;
export const DARK = ColorNames.FJORD;
export const BLACK = ColorNames.BLACK;
export const WHITE = ColorNames.WHITE;
export const CONTRAST = ColorNames.ATHENS_GRAY;
export const TEXT = ColorNames.ALABASTER;
export const TEXT_INVERSE = ColorNames.FJORD;
export const LINK_TEXT = ColorNames.MARINER;
export const SURFACE_LIGHTER = ColorNames.MINE_SHAFT; // WAS FJORED
export const SURFACE = ColorNames.THUNDER; // WAS FJORED
export const SURFACE_INVERSE = ColorNames.WHITE;
export const SURFACE_LIGHTEST = ColorNames.TUNDORA;
export const DARK_SURFACE_LIGHTER = ColorNames.TUNDORA;
export const INPUT_DISABLED = ColorNames.BLACK;
export const BOX_SHADOW = ColorNames.ATHENS_GRAY;
export const BORDER = makeBaseHex(ColorNames.MINE_SHAFT, 'X500'); // Shifts the default for this theme
export const DARK_SURFACE = ColorNames.ATHENS_GRAY;
export const DARK_BORDER = ColorNames.ATHENS_GRAY;
export const DROPDOWN_SHADOW = ColorNames.THUNDER;
export const LIGHT_GRAY_SURFACE = ColorNames.TUNDORA;
